import { apiClient, handleError } from '../api/ApiClient';
import {
  CLEAR_FEES_VALIDATION_ERRORS_SUCCESS,
  EDIT_SETTINGS_FAILURE,
  GET_SETTINGS_SUCCESS,
} from './SettingsReducer';
import { showAlert } from '../common/components/alert/AlertActions';
import AlertVariant from '../common/components/alert/AlertVariant';
import { parseCurrencyToIntIfString } from '../common/helpers/parseCurrencyToIntIfString';

const SETTINGS_ENDPOINT = '/settings';

export const fetchSettings = () => (dispatch) =>
  apiClient
    .get(`${SETTINGS_ENDPOINT}`)
    .then((res) => {
      if (res.status === 200) {
        dispatch({ type: GET_SETTINGS_SUCCESS, payload: res.data });
      }
    })
    .catch((err) => {
      dispatch(handleError(err));
    });

export const editSettings = (values) => (dispatch) => {
  const {
    monthlySubscriptionInPence,
    launchInPence,
    saleForLessThan1000InPence,
    saleBetween1001And5000InPence,
    saleBetween5001And10000InPence,
    saleBetween10001And15000InPence,
    saleForMoreThan15000InPence,
    purchaseForLessThan1000InPence,
    purchaseBetween1001And5000InPence,
    purchaseBetween5001And10000InPence,
    purchaseBetween10001And15000InPence,
    purchaseForMoreThan15000InPence,
    version,
  } = values;

  const data = {
    monthlySubscriptionInPence: parseCurrencyToIntIfString(monthlySubscriptionInPence),
    launchInPence: parseCurrencyToIntIfString(launchInPence),
    saleForLessThan1000InPence: parseCurrencyToIntIfString(saleForLessThan1000InPence),
    saleBetween1001And5000InPence: parseCurrencyToIntIfString(saleBetween1001And5000InPence),
    saleBetween5001And10000InPence: parseCurrencyToIntIfString(saleBetween5001And10000InPence),
    saleBetween10001And15000InPence: parseCurrencyToIntIfString(
      saleBetween10001And15000InPence,
    ),
    saleForMoreThan15000InPence: parseCurrencyToIntIfString(saleForMoreThan15000InPence),
    purchaseForLessThan1000InPence: parseCurrencyToIntIfString(purchaseForLessThan1000InPence),
    purchaseBetween1001And5000InPence: parseCurrencyToIntIfString(
      purchaseBetween1001And5000InPence,
    ),
    purchaseBetween5001And10000InPence: parseCurrencyToIntIfString(
      purchaseBetween5001And10000InPence,
    ),
    purchaseBetween10001And15000InPence: parseCurrencyToIntIfString(
      purchaseBetween10001And15000InPence,
    ),
    purchaseForMoreThan15000InPence: parseCurrencyToIntIfString(
      purchaseForMoreThan15000InPence,
    ),
    version,
  };

  return apiClient
    .put(`${SETTINGS_ENDPOINT}`, data)
    .then((res) => {
      if (res.status === 200) {
        dispatch(showAlert('Settings updated successfully', AlertVariant.SUCCESS));
      }
    })
    .catch((err) => {
      if (err?.response?.status === 412) {
        return dispatch({ type: EDIT_SETTINGS_FAILURE, payload: err?.response?.data?.data });
      }
      return dispatch(handleError(err));
    });
};

export const clearFeesValidationErrors = () => (dispatch) => {
  dispatch({ type: CLEAR_FEES_VALIDATION_ERRORS_SUCCESS });
};
